var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSocialLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "nonzero",
    d: "M13.598,4.874 C14.6733333,5.242 15.962,6.256 16,8.99533333 L16,15.6666667 C16,15.8506667 15.8506667,16 15.6666667,16 L12.3333333,16 C12.1493333,16 12,15.8506667 12,15.6666667 L12,9.66666667 C12,8.91 11.6846667,8.342 11.134,8.10933333 C10.566,7.868 9.872,8.016 9.33333333,8.48 L9.33333333,15.6666667 C9.33333333,15.8506667 9.184,16 9,16 L5.66666667,16 C5.48266667,16 5.33333333,15.8506667 5.33333333,15.6666667 L5.33333333,5.66666667 C5.33333333,5.48266667 5.48266667,5.33333333 5.66666667,5.33333333 L9,5.33333333 C9.15533333,5.33333333 9.286,5.44 9.32266667,5.58333333 C10.3913333,4.81466667 12.1733333,4.386 13.598,4.874 Z M3.66666667,5.33333333 C3.85066667,5.33333333 4,5.48266667 4,5.66666667 L4,15.6666667 C4,15.8506667 3.85066667,16 3.66666667,16 L0.333333333,16 C0.149333333,16 0,15.8506667 0,15.6666667 L0,5.66666667 C0,5.48266667 0.149333333,5.33333333 0.333333333,5.33333333 L3.66666667,5.33333333 Z M2,4 C0.8954305,4 0,3.1045695 0,2 C0,0.8954305 0.8954305,0 2,0 C3.1045695,0 4,0.8954305 4,2 C4,3.1045695 3.1045695,4 2,4 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FFF",
    fillOpacity: 0.01
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialLinkedin);
export default __webpack_public_path__ + "static/media/ic-social-linkedin.55f2b6a843180496d76c92d8ed56f430.svg";
export { ForwardRef as ReactComponent };